import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {DbTextPipe} from "../../../../shared/pipes/db-text.pipe";


interface ITab {
  id: 'widgets' | 'pages' | 'dashboard';
  label: string;
}

@Component({
    selector: 'db-ecommerce-disabled',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './ecommerce-disabled.component.html',
    styleUrls: ['./ecommerce-disabled.component.scss'],
    standalone: false
})


export class EcommerceDisabledComponent implements OnInit {

  public tabs: ITab[] = [
    { id: 'widgets', label: 'text_premiumWidgetsTemplates' },
    { id: 'pages', label: 'text_createProductPagesAI' },
    { id: 'dashboard', label: 'text_allInOneEcommerceDashboard' }
  ];
  public activeTab: ITab['id'] = this.tabs[0].id;
  public features: string[];
  private featuresMap = {
    widgets: [
      'text_12PremiumWidgets',
      'text_tailorMadePersonalization',
      'text_extensiveTemplateVariety'
    ],
    pages: [
      'text_aiProductDescription',
      'text_generateProductTitles',
      'text_boostSales'
    ],
    dashboard: [
      'text_allInOneProductManagement',
      'text_integratedAnalytics',
      'text_ecommerceFeatures4'
    ]
  };

  @Input() loading: boolean;
  @Output() onEnable: EventEmitter<void> = new EventEmitter<void>();

  constructor(private _dbText: DbTextPipe) {
  }

  ngOnInit() {
    this.features = this.featuresMap[this.activeTab];
  }

  public setActiveTab(tabId: string): void {
    this.activeTab = tabId as ITab['id'];
    this.features = this.featuresMap[this.activeTab];
  }

}
